export const APP_STARTED = 'APP_STARTED';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_ADMIN_AUTH = 'INITIALIZE_ADMIN_AUTH';
export const APP_INTEGRATIONS_REQUESTED = 'APP_INTEGRATIONS_REQUESTED';
export const APP_INTEGRATIONS_RECEIVED = 'APP_INTEGRATIONS_RECEIVED';
export const APP_INTEGRATIONS_FAILED = 'APP_INTEGRATIONS_FAILED';
export const APP_CONNECTION_CANCELLED = 'APP_CONNECTION_CANCELLED';
export const APP_CONNECTION_ADMIN_REQUIRED = 'APP_CONNECTION_ADMIN_REQUIRED';
export const APP_CONNECTION_INVALID_LICENSE = 'APP_CONNECTION_INVALID_LICENSE';
export const APP_CONNECTION_PERMISSIONS_REQUIRED = 'APP_CONNECTION_PERMISSIONS_REQUIRED';
export const APP_CONNECTION_THIRD_PARTY_UNAVAILABLE = 'APP_CONNECTION_THIRD_PARTY_UNAVAILABLE';
export const APP_CONNECTION_GENERIC_FAILED = 'APP_CONNECTION_GENERIC_FAILED';
export const ADMIN_FETCH_REQUESTED = 'ADMIN_FETCH_REQUESTED';
export const ADMIN_FETCH_RECEIVED = 'ADMIN_FETCH_RECEIVED';
export const ADMIN_FETCH_FAILED = 'ADMIN_FETCH_FAILED';
export const EMAIL_ADMIN_REQUESTED = 'EMAIL_ADMIN_REQUESTED';
export const EMAIL_ADMIN_RECEIVED = 'EMAIL_ADMIN_RECEIVED';
export const EMAIL_ADMIN_FAILED = 'EMAIL_ADMIN_FAILED';
export const HUB_FETCH_REQUESTED = 'HUB_FETCH_REQUESTED';
export const HUB_FETCH_RECEIVED = 'HUB_FETCH_RECEIVED';
export const HUB_FETCH_FAILED = 'HUB_FETCH_FAILED';
export const DETAILS_FETCH_REQUESTED = 'DETAILS_FETCH_REQUESTED';
export const DETAILS_FETCH_RECEIVED = 'DETAILS_FETCH_RECEIVED';
export const DETAILS_FETCH_FAILED = 'DETAILS_FETCH_FAILED';
export const FEATURE_COMPATIBILITY_REQUESTED = 'FEATURE_COMPATIBILITY_REQUESTED';
export const FEATURE_COMPATIBILITY_RECEIVED = 'FEATURE_COMPATIBILITY_RECEIVED';
export const FEATURE_COMPATIBILITY_FAILED = 'FEATURE_COMPATIBILITY_FAILED';
export const DETAILS_MORE_APPS_FETCH_REQUESTED = 'DETAILS_MORE_APPS_FETCH_REQUESTED';
export const DETAILS_MORE_APPS_FETCH_RECEIVED = 'DETAILS_MORE_APPS_FETCH_RECEIVED';
export const DETAILS_MORE_APPS_FETCH_FAILED = 'DETAILS_MORE_APPS_FETCH_FAILED';
export const DETAILS_MORE_APPS_RESET = 'DETAILS_MORE_APPS_RESET';
export const DETAILS_REFERRER_SET = 'DETAILS_REFERRER_SET';
export const DETAILS_REFERRER_RESET = 'DETAILS_REFERRER_RESET';